import httpRequest from "@/auth/http-client";
import { buildPaginationQuery } from "@/helpers/request-helpers";
import { IWorkflowStep, IWorkflowStepInput } from "@/interfaces/workflow-step.interface";
import { IFilter } from "@/types/filter.types";
import { PaginatedResponse, RequestPagination } from "@/types/requests.types";

class WorkflowStepService {
  private baseUrl = "api/v1/workflowstep";

  async getAll(pagination: RequestPagination): Promise<PaginatedResponse<IWorkflowStep>> {
    const paginationQuery = buildPaginationQuery(pagination);

    const workflowSteps = await httpRequest.get(`${this.baseUrl}?${paginationQuery}`);
    return workflowSteps;
  }

  async filter(
    filter: IFilter<IWorkflowStep>[],
    pagination: RequestPagination
  ): Promise<PaginatedResponse<IWorkflowStep>> {
    const paginationQuery = buildPaginationQuery(pagination);

    const response = await httpRequest.post(`${this.baseUrl}/filter?${paginationQuery}`, {
      filter,
    });

    return response;
  }

  async getById(workflowStepId: number): Promise<IWorkflowStep> {
    const workflowStep = await httpRequest.get(`${this.baseUrl}/${workflowStepId}`);
    return workflowStep;
  }

  async create(formData: IWorkflowStepInput): Promise<IWorkflowStep> {
    return await httpRequest.post(this.baseUrl, formData);
  }

  async update(formData: IWorkflowStepInput, workflowStepId: number): Promise<void> {
    return await httpRequest.put(`${this.baseUrl}/${workflowStepId}`, formData);
  }

  async delete(workflowStepId: number): Promise<void> {
    await httpRequest.delete(`${this.baseUrl}/${workflowStepId}`);
  }
}

const workflowStepService = new WorkflowStepService();
export default workflowStepService;
